<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.region.update")}}</span>
    <div v-if="dataLoaded" class="form-container">
      <AveineRegionForm :APIbaseURL="APIbaseURL" :region="region" :adminMode="true" />
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineRegionForm } from 'aveine-region';
import { Region } from 'aveine-toolbox';
import { errorHandler } from 'aveine-toolbox'
export default {
  watch: {
  },
  data () {
    return {
      region: {},
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Create',
  components: {
    AveineRegionForm
  },
  async created() {
    try {
      await Region.api().get(`regions/${this.$route.params.id}?lang=${this.$i18n.locale}`, {
          params: {
            include:
            'country,' +
            'spatial-information',
          }
        }
      );
      this.region = await Region.query().whereId(this.$route.params.id).withAllRecursive().first();
      this.dataLoaded = true;
    } catch (errors) {
      this.dataLoaded = true;
      errorHandler(errors, this)
    }
  }
}
</script>
